import Cookies from "js-cookie";

/**
 * Cookie configuration for secure token storage
 * These settings ensure proper session isolation across tabs and contexts
 */
const COOKIE_CONFIG = {
  expires: 7, // 7 days
  sameSite: "Strict" as const, // Strict for better isolation
  secure:
    typeof window !== "undefined" && window.location.protocol === "https:", // Only HTTPS in production
  path: "/", // Available across entire site
};

/**
 * Store authentication token in a secure cookie
 * @param token - JWT authentication token
 */
export const setAuthToken = (token: string): void => {
  // Remove any existing token first to ensure clean state
  Cookies.remove("token", { path: "/" });
  // Set new token with strict configuration
  Cookies.set("token", token, COOKIE_CONFIG);
};

/**
 * Retrieve authentication token from cookie
 * @returns Token string or undefined if not found
 */
export const getAuthToken = (): string | undefined => {
  return Cookies.get("token");
};

/**
 * Remove authentication token from cookie (logout)
 */
export const removeAuthToken = (): void => {
  Cookies.remove("token", { path: "/" });
};

/**
 * Check if user is authenticated by verifying token existence
 * @returns Boolean indicating if token exists
 */
export const isAuthenticated = (): boolean => {
  return !!getAuthToken();
};
